/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MukUrlApiRoaming } from '../../models/muk-url-api-roaming';

export interface ApiRoamingMukUrlsGet$Params {

/**
 * Localization.
 */
  lang?: string;
}

export function apiRoamingMukUrlsGet(http: HttpClient, rootUrl: string, params?: ApiRoamingMukUrlsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MukUrlApiRoaming>>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingMukUrlsGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MukUrlApiRoaming>>;
    })
  );
}

apiRoamingMukUrlsGet.PATH = '/api/Roaming/MukUrls';
